import BaseModel from './BaseModel';

class Document extends BaseModel {}

Document.collection = 'Documents';

export default Document;
